import { ref } from '@vue/composition-api'
// import store from '@/store'
// import axiosIns from '../../../../libs/axios'
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: 'https://4rf1lach53.execute-api.ap-south-1.amazonaws.com/dev/programs/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

export const useShopFiltersSortingAndPagination = () => {
  const filters = ref({
    path: '',
    q: '',
    priceRangeDefined: 'all',
    priceRange: [0, 100],
    categories: [],
    brands: [],
    ratings: null,
    page: 1,
    perPage: 9,
  })

  const filterOptions = {
    priceRangeDefined: [
      { text: 'All', value: 'all' },
      { text: '<= $10', value: '<=10' },
      { text: '$10 - $100', value: '10-100' },
      { text: '$100 - $500', value: '100-500' },
      { text: '>= $500', value: '>=500' },
    ],
    categories: [
      'Appliances',
      'Audio',
      'Cameras & Camcorders',
      'Car Electronics & GPS',
      'Cell Phones',
      'Computers & Tablets',
      'Health, Fitness & Beauty',
      'Office & School Supplies',
      'TV & Home Theater',
      'Video Games',
    ],
    brands: ['Insignia™', 'Samsung', 'Metra', 'HP', 'Apple', 'GE', 'Sony', 'Incipio', 'KitchenAid', 'Whirlpool'],
    ratings: [
      { rating: 4, count: 160 },
      { rating: 3, count: 176 },
      { rating: 2, count: 291 },
      { rating: 1, count: 190 },
    ],
  }

  // Sorting
  const sortBy = ref({ text: 'Featured', value: 'featured' })
  const sortByOptions = [
    { text: 'Featured', value: 'featured' },
    { text: 'Lowest', value: 'price-asc' },
    { text: 'Highest', value: 'price-desc' },
  ]

  return {
    // Filter
    filters,
    filterOptions,

    // Sort
    sortBy,
    sortByOptions,
  }
}

export const useShopUi = () => {
  const itemView = 'grid-view'
  const itemViewOptions = [
    { icon: 'GridIcon', value: 'grid-view' },
    { icon: 'ListIcon', value: 'list-view' },
  ]

  // Pagination count <= required by pagination component
  const totalProducts = ref(null)

  return {
    itemView,
    itemViewOptions,
    totalProducts,
  }
}

export const useShopRemoteData = () => {
  const products = ref([])
  const fetchProducts = async args => {
    try {
      const tokenStr = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjM3Nzk4MDA5LCJpYXQiOjE2Mzc0OTgwMDksImp0aSI6ImQyNTIzMDU2NDBiMzQ3NDJiYmEyZWNhNmFhNzE2YjM5IiwidXNlcl9pZCI6InJpc2hhYmhAZ21haWwuY29tIn0.3buhbN_PpFGh-4190bIspPxZ_r8Jryb_ZgzlbdlD_rM'
      const response = await axiosIns.get(args.path, { headers: { authorization: `Bearer ${tokenStr}` } }) // store.dispatch('app-ecommerce/fetchProducts', ...args)
      let filterData = []
      if (args.q) {
        filterData = response.data.data.filter(x => x.title.includes(args.q))
      } else {
        filterData = response.data.data
      }
      return filterData
    } catch (e) {
      // console.log(e)
      return e
    }
  }

  return {
    products,
    fetchProducts,
  }
}
